import { Component, OnInit } from '@angular/core';
import { AppComponent } from '../../app.component';
import { AuthenticationService, PetsService } from '../../_services';
import { Router, ActivatedRoute } from "@angular/router";
import { AuthService, FacebookLoginProvider, GoogleLoginProvider } from 'angularx-social-login';
import { Socialusers } from '../../_models';
import { environment } from '../../../../src/environments/environment';
import { ViewChild, ElementRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OTPloginComponent } from 'src/app/otplogin/otplogin.component';
import { DateAdapter, MatDialog, MatDialogRef } from '@angular/material';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  socialusers = new Socialusers();
  returnUrl: string;
  public referPage: any = "";
  referUrl: string;
  currentUser: any;
  isLogin: boolean = false;
  sidebar: boolean = false;
  @ViewChild('closeLoginModal') closeLoginModal: ElementRef;
  lostPath: string;
  foundPath: string;
  homepath: string;
  showProfile: boolean = true;

  constructor(public app: AppComponent,
    private router: Router,
    private authService: AuthService,
    private authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private petsService: PetsService,
    private LoginOTPPopup: MatDialog) {
  }

  ngOnInit() {
    debugger;
    if(this.app.currentUser != null && this.app.currentUser.LastName == null){
      this.app.currentUser.LastName = "";
    }
    this.petsService.openLoginPopup.subscribe((res: any) => {
      if (res) {
        this.returnUrl = res.queryParams.returnUrl
        this.toggleModal();
      }
    })
    this.referUrl = this.route.snapshot.queryParams['refer'];
    this.referPage = this.route.snapshot.queryParams['referPage'];
    if (this.referUrl == "minside") {
      if (localStorage["socialusers"] == undefined || localStorage["socialusers"] == null) {
        this.LoginWithMinside();
      } else {
        // User Logged IN 
        this.currentUser = this.authenticationService.currentUserValue;
        var userProvider = this.currentUser.Provider.toLowerCase();
        var username = "";
        var email = this.currentUser.EmailID;
        if (email == null) {
          username = this.currentUser.ContactNumber;
        } else {
          username = email.toLowerCase();
        }

        var flag = confirm("User (" + username + ") already logged in from (" + userProvider + "). Do you wanted to end Current Session ?");
        if (flag) {
          this.authenticationService.logout();
          this.router.navigate(['login']);
          this.LoginWithMinside();
        } else {
          if ((userProvider == 'facebook') || (userProvider == 'google')) {
            this.router.navigate(['']);
          }
          else {
            if (this.referPage == "found") {
              alert(environment.lostFoundBaseUrl);
              window.location.href = `${environment.lostFoundBaseUrl}/report-found`;
            } else {
              window.location.href = `${environment.lostFoundBaseUrl}/report-lost`;
            }
          }
        }
      }
    }

    this.showProfile = true;
    if (this.authenticationService.currentUserValue) {
      this.currentUser = this.authenticationService.currentUserValue;
      let provider = this.currentUser.Provider.toLowerCase();
      this.showProfile = provider != 'company' ? true : false;
    }

    this.lostPath = environment.lostFoundBaseUrl + 'search/lost';
    this.foundPath = environment.lostFoundBaseUrl + 'search/found';
    this.homepath = environment.lostFoundBaseUrl;
  }

  public _toggleSidebar() {
    this.app._opened = !this.app._opened;
  }

  public socialSignIn(socialProvider: string) {  // Just Add Google

    let socialPlatformProvider;
    if (socialProvider === 'facebook') {
      socialPlatformProvider = FacebookLoginProvider.PROVIDER_ID;
    } else if (socialProvider === 'google') {
      socialPlatformProvider = GoogleLoginProvider.PROVIDER_ID;
    }

    this.authService.signIn(socialPlatformProvider).then(user => {
      this.socialusers.SocialID = user.id;
      this.socialusers.FirstName = user.firstName;
      this.socialusers.LastName = user.lastName;
      this.socialusers.EmailID = user.email;
      this.socialusers.AuthToken = user.authToken;
      this.socialusers.Provider = user.provider;
      this.Savesresponse(this.socialusers);
    });
  }


  LoginWithMinside() {    /// Just Add DyreId  
    let h = 500;
    let w = 500;
    var y = window.outerHeight / 2 + window.screenY - (h / 2)
    var x = window.outerWidth / 2 + window.screenX - (w / 2)

    let currentPage = this.router.url;
    if (currentPage == '/search/lost') {
      var minsideUrl = environment.urlMinsideLogin + '&referPage=found';
    }
    else if (currentPage == '/search/found') {
      var minsideUrl = environment.urlMinsideLogin + '&referPage=lost';
    }
    else if (this.referPage != null) {
      var minsideUrl = environment.urlMinsideLogin + '&referPage=' + this.referPage;
    } else {
      var minsideUrl = environment.urlMinsideLogin;
    }

    var popup = window.open(`${minsideUrl}`, "Popup", "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=" + w + ", height=" + h + ", top=" + y + ", left=" + x);
    popup.open();
  }

  Savesresponse(socialusers: Socialusers) {
    this.closeLoginModal.nativeElement.click();
    let currentUrl = '';
    // this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';  
    this.authenticationService.login(socialusers).subscribe((res: any) => {
      this.socialusers = res.data;
      const today =  new Date();
      const tomorrow =  new Date(today.setDate(today.getDate() + 1));
      document.cookie = 'Authorization='+ res.JWTToken +'; expires=' + tomorrow;
      localStorage.setItem('socialusers', JSON.stringify(this.socialusers));
      if (this.returnUrl) {
        this.router.navigate([this.returnUrl]);
      }
      window.location.reload();
    })
  }

  toggleModal = () => {
    this.isLogin = !this.isLogin;
    this.currentUser = this.authenticationService.currentUserValue;
    if (!this.currentUser) {
      this.router.navigate(['/']);
    }
  }

  open(content) {
    this.modalService.open(content, { size: 'lg', ariaLabelledBy: 'modal-basic-title', backdrop: 'static', windowClass: 'my-modal-popup' }).result.then((result) => {
      //return false;
    }, (reason) => {
    });
    return false;
  }

  toggleSidebar = () => {
    this.sidebar = !this.sidebar;
  }
  LoginWithOTP() {   
    if(this.returnUrl == null) {
      this.returnUrl = "";
    }
    this.LoginOTPPopup.open(OTPloginComponent, {
      width: "450px",
     // height: "auto!important",
      data: this.returnUrl,
      panelClass: 'privacy-dialog-class',
      autoFocus: false
    });
    //var popup = window.open(`${minsideUrl}`, "Popup", "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=" + w + ", height=" + h + ", top=" + y + ", left=" + x);
    //popup.open();
  }
}
